import { render, staticRenderFns } from "./pbi-dealer-evaluation.page.vue?vue&type=template&id=9aebde72"
import script from "./pbi-dealer-evaluation.page.vue?vue&type=script&lang=ts"
export * from "./pbi-dealer-evaluation.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports